/* Component Dependencies */

var emailPreferencesTemplate = require('templates/emailPreferences.hbs');
var emailPreferencesUnsubscribeTemplate = require('templates/emailPreferences-unsubscribe.hbs');

var AriesComponent = require('libs/aries-component');

var PubSub = require('libs/pub-sub');

var MailPreferences = require('rewards_libs/mailPreferences');



PubSub.register(MailPreferences.extend({

  type: 'emailPreferences',

  template: {

    'emailPreferences': emailPreferencesTemplate,
    'emailPreferences-unsubscribe':emailPreferencesUnsubscribeTemplate

  },

  bindEvents: function() {

    var _self = this;

    _self.$el.submit(_self.submitEmailPreferences.bind(_self));
     $(_self.$el.find('.js-countries-list')).on('change', _self.checkIfDEToUncheck.bind(_self));
	 if($('.label')[0].innerHTML=="Deutschland")
	{
		$('.uncheckAllLabel')[0].click();
	}	
  },

 events: {

    'click .uncheckAllLabel': 'uncheckAllCheckbox',
    'click .selectAllLabel': 'selectAllCheckbox'

    },

  /**

   * This function is used to add data required by PLAY service to hidden input field

   * before submitting form

   * @returns {Boolean} Returns status of the operation success or failure

   */

  submitEmailPreferences: function _submitEmailPreferences() {

    var _self = this;

    _self.preferences = 'emailPreferences';

    _self.$el.find('.js-email-preferences-data-field').val(_self.getXHRPayload());

    return true;

  },

   checkAllCheckbox: function _checkAllCheckbox() {
    if($('#unsubscribeAll').val() == "false"){
      $("input[type= checkbox]").prop("checked",true);  
    }
    
  },
  
  checkIfDEToUncheck: function _checkIfDEToUncheck() {
	if($('.label')[0].innerHTML=="Germany")
	{
		$('.uncheckAllLabel')[0].click();
	}
  else {
    $("input[type= checkbox]").prop("checked",true);  
  }
  },
  
 uncheckAllCheckbox: function _uncheckAllCheckbox(){

    $("input[type= checkbox]").prop("checked",false);

  },
  selectAllCheckbox: function _selectAllCheckbox(){
    $("input[type= checkbox]").prop("checked",true);
  }
}));